import React from 'react'

import PropTypes from 'prop-types'

import './footer-main.css'

const FooterMain = (props) => {
  return (
    <footer
      className={`footer-main-container1 thq-section-padding ${props.rootClassName} `}
    >
      <div className="footer-main-thq-row-elm">
        <div className="footer-main-thq-credits-elm">
          <span className="text_medium thq-body-small">© 2026 Arcobo</span>
          <span className="text_medium thq-body-small">
            Казахстан, г.  Алматы, ул. Митина 4/1
          </span>
          <a
            href="tel:+7 747 13 747 13"
            className="footer-main-thq-link13-elm1 text_medium thq-body-small"
          >
            +7 747 13 747 13
          </a>
          <a
            href="mailto:info@arcobo.tech?subject="
            className="footer-main-thq-link13-elm2 thq-body-small text_medium"
          >
            info@arcobo.tech
          </a>
        </div>
        <div className="footer-main-thq-social-links-elm">
          <h2 className="footer-main-text H1_extrasmall">Свяжитесь с нами:</h2>
          <div className="footer-main-container2">
            <a
              href="https://wa.me/77471374713"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-main-link1"
            >
              <img
                alt="WhatsApp"
                src="/contact-icons/whatsapp-200h.webp"
                className="footer-main-image1"
              />
            </a>
            <a
              href="https://t.me/arcobo_robotics"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-main-link2"
            >
              <img
                alt="Telegram"
                src="/contact-icons/telegram-200h.webp"
                className="footer-main-image2"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/arcobotech/?viewAsMember=true"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-main-link3"
            >
              <img
                alt="LinkedIn"
                src="/contact-icons/linkedin-200h.webp"
                className="footer-main-image3"
              />
            </a>
            <a
              href="https://www.instagram.com/arcobotech/"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-main-link4"
            >
              <img
                alt="Instagram"
                src="/contact-icons/instagram-200h.webp"
                className="footer-main-image4"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

FooterMain.defaultProps = {
  rootClassName: '',
}

FooterMain.propTypes = {
  rootClassName: PropTypes.string,
}

export default FooterMain
